import mixpanel from 'mixpanel-browser';

export function trackLink(event: MouseEvent) {
	const target = event.currentTarget as HTMLAnchorElement;

	mixpanel.track(
		'Link Clicked',
		{
			type: target.dataset?.type,
			content: target.dataset?.content,
			text: target.innerText,
			url: target.href
		},
		{
			send_immediately: true,
			transport: 'sendBeacon'
		}
	);
}

export function trackButton(event: MouseEvent) {
	const target = event.currentTarget as HTMLButtonElement;

	mixpanel.track(
		'Button Clicked',
		{
			type: target.dataset?.type,
			content: target.dataset?.content,
			text: target.innerText
		},
		{
			send_immediately: true
		}
	);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function trackEvent(eventName: string, properties: Record<string, any> = {}) {
	mixpanel.track(eventName, properties, {
		send_immediately: true
	});
}

export function observeDOM(obj: HTMLElement, callback: (node: Node) => void) {
	if (!obj || obj.nodeType !== 1) return;

	if (MutationObserver) {
		const mutationObserver = new MutationObserver((mutations: MutationRecord[]) => {
			mutations.forEach((record) => {
				record.addedNodes.forEach((node) => {
					callback(node);
				});
			});
		});
		mutationObserver.observe(obj, { childList: true, subtree: true });
		return mutationObserver;
	}
}
